<div class="popup-global-layout width-650 p-4 p-md-5">
  <div class="d-flex justify-content-end"><mat-icon class="icon" (click)="close()">close</mat-icon></div>
  <div class="global-title">Update Confirmed!</div>
  <div class="global-yellow-bar"></div>
  <div class="global-text">Your change has been successfully updated.</div>
  <div class="global-button-format">
    <button (click)="close()" class="dw-primary-button icon-right">Thank You<mat-icon class="black">keyboard_arrow_right</mat-icon></button>
  </div>
</div>